import React from 'react';
import { CustomComponentsProps } from '@website-editor/customComponents/CustomComponents';
import { JsonComponentEditor } from './JsonComponentEditor';
import { JSON_COMPONENT_ACTIONS } from './JsonComponent.constants';

interface RichTextNavigationsProps extends CustomComponentsProps {}

export const getJsonComponentNavigations = (props: RichTextNavigationsProps) => {
  const jsonComponentAdd = (
    <JsonComponentEditor
      type={JSON_COMPONENT_ACTIONS.JSON_COMPONENT_ADD}
      {...props}
    />
  );
  // TODO: Add 'isEditMode'-type flag. So JsonComponentEditor --> JsonComponentSwitch --> final component knows we are EDITING, not adding.
  const jsonComponentEdit = (
    <JsonComponentEditor
      isEditMode
      type={JSON_COMPONENT_ACTIONS.JSON_COMPONENT_EDIT}
      {...props}
    />
  );
  return [jsonComponentAdd, jsonComponentEdit];
};
